"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatorType = exports.IntegrationType = void 0;
var IntegrationType;
(function (IntegrationType) {
    IntegrationType[IntegrationType["Fleet"] = 1] = "Fleet";
    IntegrationType[IntegrationType["Aggregator"] = 2] = "Aggregator";
    IntegrationType[IntegrationType["POS"] = 3] = "POS";
})(IntegrationType || (exports.IntegrationType = IntegrationType = {}));
var AggregatorType;
(function (AggregatorType) {
    AggregatorType[AggregatorType["Uber"] = 1] = "Uber";
    AggregatorType[AggregatorType["Loggi"] = 3] = "Loggi";
    AggregatorType[AggregatorType["Ifood"] = 5] = "Ifood";
    AggregatorType[AggregatorType["McdPOS"] = 6] = "McdPOS";
    AggregatorType[AggregatorType["Vtex"] = 7] = "Vtex";
    AggregatorType[AggregatorType["Toast"] = 8] = "Toast";
    AggregatorType[AggregatorType["GoogleFood"] = 9] = "GoogleFood";
    AggregatorType[AggregatorType["Popeyes"] = 10] = "Popeyes";
})(AggregatorType || (exports.AggregatorType = AggregatorType = {}));
//# sourceMappingURL=external_data_team.js.map